function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import styles from './Button.module.css';

/**
 * @typedef {object} LinkButtonClassNameProps
 * @property {("primary"|"secondary"|"tertiary")} props.buttonType - primary = green, secondary - white, tertiary = text-only
 * @property {string=} props.className - classes to add to button
 * @property {boolean=} props.dark - dark mode for button
 * @property {boolean=} props.disabled - disabled state
 * @property {boolean=} props.floating - "floating" styles for button positioned fixed over content
 */

/** @param {LinkButtonClassNameProps} props */
export function deriveLinkButtonClasses({
  buttonType,
  dark,
  floating,
  className = '',
  disabled
}) {
  const classes = [styles[`${buttonType}Button`]];
  if (dark) {
    classes.push(styles.dark);
  }
  if (floating) {
    if (buttonType === 'tertiary') {
      throw new Error('Floating buttons cannot be tertiary');
    }
    classes.push(styles.floating);
  }
  if (className.length) {
    classes.push(...className.split(' '));
  }
  if (disabled) {
    classes.push(styles.disabled);
  }
  return classes.join(' ');
}

/**
 * @param {LinkButtonClassNameProps & React.DetailedHTMLProps<React.AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>} props
 */
export default function LinkButton({
  buttonType,
  children,
  className = '',
  dark = false,
  disabled = false,
  floating = false,
  href,
  ...otherProps
}) {
  const classesString = deriveLinkButtonClasses({
    buttonType,
    dark,
    floating,
    className,
    disabled
  });
  return /*#__PURE__*/React.createElement("a", _extends({}, otherProps, {
    className: classesString,
    href: href
  }), children);
}